export const SIGNIN_BY_EMAIL = 'siginByEmail';
export const SIGNIN_BY_TEXT = 'siginByText';
